import { PasswordResetRequestForm } from '@/pages/PasswordResets/RequestForm'

export default function PlayerPasswordResetNew() {
  return (
    <PasswordResetRequestForm
      title="選手パスワード再設定"
      description="登録済みのメールアドレスに再設定リンクを送信します。"
      postPath="/player/password_resets"
      loginPath="/player/login"
    />
  )
}
